<template>
  <div>
    <van-dialog v-model="dialogShow" title="Tip" :showConfirmButton="false">
      <div class="visit-dialog-content">
        <!-- 当前 Store Tag 为：xxxxx，是否变更 Store Tag? -->
        <div class="link-tip" v-if="currentVisitInfo.customerInfo">{{ $t('tips.messageFortyFive', { customerTag: currentVisitInfo.customerInfo.customerTag | formatTag }) }}</div>
        <div class="dialog-btn">
          <van-button color="#307bff" class="xu-btn copy-notice" type="info" @click="handleOper('update')">{{ $t('shared.modifyStoreTag') }}</van-button>
          <!-- <van-button color="#307bff" class="xu-btn give-up-btn" plain type="info" @click="handleOper('giveup')">Kick out following up on the store</van-button> -->
          <van-button color="#307bff" class="xu-btn" plain type="info" @click="handleOper">{{ $t('shared.notChangedYet') }}.</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog, Toast, Notify } from 'vant'
import { waiveCustomerApi } from '@/api/storeMaintain'
import i18n from '@/i18n'
export default {
  props: {
    currentVisitInfo: {
      type: Object,
      default: () => {}
    },
    customerId: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    }
  },
  data () {
    return {
      dialogShow: false
    }
  },
  created () {
    this.dialogShow = false
  },
  activated () {
    this.dialogShow = false
  },
  methods: {
    handleOper (type) {
      this.dialogShow = false
      if (type === 'update') {
        const { customerInfo, id } = this.currentVisitInfo
        this.$router.replace(`/shared/storeTag?pageType=storeMaintain&customerTag=${customerInfo.customerTag}&visitId=${id}&customerId=${customerInfo.id}`)
      } else if (type === 'giveup') {
        Dialog.confirm({
          // 确认转移该门店并分配给指定负责人吗？
          message: `<div><i class="van-icon van-icon-info-o" style="font-size: 48px; color: #c4200b; margin-bottom: 15px;"></i><div style="line-height: 1.5;">${this.$t('tips.messageFortySix')}.</div></div>`,
          confirmButtonText: this.$t('shared.kickOut'),
          cancelButtonText: this.$t('button.cancel'),
          confirmButtonColor: '#c4200b'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            const data = {
              visitId: this.currentVisitInfo.id,
              eventId: '',
              customerId: this.currentVisitInfo.customerInfo.id
            }
            waiveCustomerApi(data).then(res => {
              Toast.clear()
              Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
              this.$router.go(-1)
            }).catch(() => {})
          })
          .catch(() => {
            // on cancel
            this.$router.go(-1)
          })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.visit-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
  font-size: 14px;
  .link-txt {
    width: 200px;
  }
  .link-tip {
    font-size: 14px;
    margin-top: 10px;
  }
  .dialog-btn {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    .xu-btn {
      width: 100%;
      margin-bottom: 10px;
    }
    .give-up-btn {
      color: #c4200b !important;
      border: 1px solid #c4200b !important;
    }
  }
}
</style>
